<template>
  <ButtonDropdownOptions
    v-if="has_dropdown"
    class="min-w-0 flex-1"
    :data_test="data_test"
  >
    <template #custom_trigger>
      <div
        class="min-w-0 cursor-pointer rounded-md transition-colors duration-200 hover:bg-primary-100"
        :class="
          is_expanded
            ? 'flex w-fit max-w-full items-center gap-2 px-2 py-1'
            : 'mx-auto flex size-9 items-center justify-center'
        "
      >
        <Avatar
          class="shrink-0"
          size="32"
          :format="avatar_format"
          :src="client.attributes.picture_logo_url_s"
          :username="client.attributes.name"
        />
        <span
          v-if="is_expanded"
          class="min-w-0 truncate text-sm font-semibold text-gray-800"
          :title="client.attributes.name"
        >
          {{ client.attributes.name }}
        </span>
        <FontAwesomeIcon
          v-if="is_expanded"
          icon="chevron-down"
          class="shrink-0 text-gray-400"
          size="sm"
        />
      </div>
    </template>
    <slot />
  </ButtonDropdownOptions>

  <div
    v-else
    class="min-w-0 flex-1"
    :class="is_expanded ? 'flex items-center gap-2 px-2 py-1' : 'mx-auto flex size-9 items-center justify-center'"
  >
    <Avatar
      class="shrink-0"
      size="32"
      :format="avatar_format"
      :src="client.attributes.picture_logo_url_s"
      :username="client.attributes.name"
    />
    <span
      v-if="is_expanded"
      class="min-w-0 truncate text-sm font-semibold text-gray-800"
      :title="client.attributes.name"
    >
      {{ client.attributes.name }}
    </span>
  </div>
</template>

<script setup>
import ButtonDropdownOptions from '@/app/shared_components/buttons/ButtonDropdownOptions.vue';

defineProps({
  client: { type: Object, required: true },
  is_expanded: { type: Boolean },
  avatar_format: { type: String, default: undefined },
  data_test: { type: String, default: null },
  has_dropdown: { type: Boolean, default: true },
});
</script>
